export const BIO_CATEGORIES = new Set(["cultures", "work_in_progress"]);
export const BOM_CATEGORIES = new Set(["work_in_progress", "products"]);
export const PARENT_CATEGORIES = new Set(["cultures"]);

export const CATEGORY_LABELS = {
  materials:        "Materials",
  supplies:         "Supplies",
  cultures:         "Cultures",
  work_in_progress: "Work in Progress",
  products:         "Products",
};

export const CATEGORY_ORDER = ["cultures", "work_in_progress", "materials", "supplies", "products"];
